<template>
  <FlotoScrollDropdown
    :options="availableFilteredSources"
    :show-no-data="false"
    @change="selectItem"
    @active-item-index-change="selectedIndex = $event"
  >
    <template v-slot:trigger>
      <MInput
        id="main-content"
        ref="searchBox"
        v-model="searchText"
        :max="255"
        :placeholder="searchBarPlaceholder"
        class="search-param-selector"
        @enterKey="enterHandler"
        @keydown="handleKeyDown"
      />
    </template>
    <template v-slot:menu-item="{ item, selectItem: selectItemFromDropdown }">
      <a
        :id="`dropdown-${item.name}`"
        href="javascript:;"
        @click="selectItemFromDropdown(item)"
      >
        {{ item.name }}
      </a>
    </template>
  </FlotoScrollDropdown>
</template>

<script>
import { searchList } from '@utils/arr'
import { keyEvents } from '@utils/keyevents'

export default {
  name: 'ParamSelector',
  props: {
    sources: { type: Array, required: true },
    // eslint-disable-next-line
    allowKeywords: { type: Boolean, default: true },
    searchBarPlaceholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      selectedIndex: undefined,
      filteredSources: [],
    }
  },
  computed: {
    availableFilteredSources() {
      return this.filteredSources.map((o) => ({ ...o, disabled: o.hidden }))
    },
  },
  watch: {
    sources: 'updateFilteredSources',
    searchText: {
      immediate: true,
      handler: 'updateFilteredSources',
    },
  },
  methods: {
    reset() {
      this.searchText = ''
    },
    handleKeyDown($event) {
      const searchBox = this.$refs.searchBox

      // Check if it's a KeyboardEvent and handle spacebar and backspace
      if ($event instanceof KeyboardEvent) {
        // Prevent spacebar behavior if search box is empty
        if (!searchBox.value) {
          if ($event.key === keyEvents.SPACE) {
            // Prevent space from being typed
            $event.preventDefault()
            // Open the dropdown
            if (searchBox) {
              searchBox.$el.click()
            }
          }

          // Handle the backspace key if necessary
          if ($event.key === 'Backspace') {
            // Custom logic for backspace key
            this.$emit('remove')
          }
        }
      }
    },
    updateFilteredSources() {
      if (!this.searchText) {
        this.filteredSources = this.sources
        return
      }
      this.filteredSources = searchList(this.sources, this.searchText)
    },
    enterHandler(e) {
      e.preventDefault()
      e.stopPropagation()
      if (!this.allowKeywords) {
        return
      }
      if (this.searchText && this.searchText.length > 255) {
        return this.$errorNotification({
          message: this.$t('error'),
          description: this.$t('search_keyword_validation_message'),
        })
      }
      if (this.filteredSources.length) {
        // here the item is selected
        this.selectItem(this.filteredSources[this.selectedIndex])
      } else {
        // here its new keyword
        this.selectItem({ keyword: this.searchText })
      }
    },
    focusOnInput() {
      this.$refs.searchBox.focus()
    },
    selectItem(sourceKey) {
      if (typeof sourceKey === 'object' && 'keyword' in sourceKey) {
        this.$emit('selected', sourceKey)
      } else {
        const source = this.filteredSources.find((s) => s.key === sourceKey)
        // removed adadvancedSearchParam error from console
        if (source && source.advancedSearchParam) {
          this.$emit('advanced-search-param-selected', source)
        } else {
          this.$emit('selected', source)
        }
      }
    },
  },
}
</script>

<style lang="less">
.search-param-selector,
.search-param-selector > input {
  padding: 0;
  background-color: var(--page-background-color);
  border: none !important;

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
}
</style>
